import { render, staticRenderFns } from "./PaymentExpired.vue?vue&type=template&id=51a18ae2"
import script from "./PaymentExpired.vue?vue&type=script&lang=js"
export * from "./PaymentExpired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports